import { jsxs as _jsxs } from "react/jsx-runtime";
import pluralize from "pluralize";
import { SEARCH_RESULTS_TEXT } from "~/constants/testIDs";
export const SearchResultsNumber = (param)=>{
    let { total, location } = param;
    return total ? /*#__PURE__*/ _jsxs("div", {
        className: "truncate text-14 text-grey-11",
        "data-testid": SEARCH_RESULTS_TEXT,
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "font-semibold",
                children: [
                    total.toLocaleString(),
                    "\xa0",
                    pluralize("result", total)
                ]
            }),
            !!location && /*#__PURE__*/ _jsxs("span", {
                children: [
                    " ",
                    "in ",
                    location
                ]
            })
        ]
    }) : null;
};
